/* eslint-disable @typescript-eslint/no-explicit-any */
import { Alert, AlertIcon } from '@chakra-ui/react'
import * as React from 'react'

interface AlertProps {
  message?: string
}

const alert: React.FC<AlertProps> = ({ message }) => {
  return (
    <Alert
      mb="5%"
      status="error"
      fontSize="18px"
      fontWeight="400"
      borderRadius="8px"
      border="1px solid #FFFFFFB2#F72C40"
      backgroundColor="#FFFFFFB2#F72C40"
      color="#F72C40"
      alignItems="flex-start"
    >
      <AlertIcon mt="2%" />
      {message}
    </Alert>
  )
}

export default alert
